import React from 'react';
import { Cta1, SubpageBanner } from '../components';
import { useTranslation } from 'react-i18next';

const KYCNasilYapilir = () => {
    const { t } = useTranslation();

    return (
        <div className="subpage-content">
            {/* Page Banner */}
            <SubpageBanner 
                title={t('kycNasilYapilir.bannerTitle')}
                path="/nordex-academy"
            />

            <div className="academy-page">
                {/* Giriş */}
                <div className="academy-intro-section py-5">
                    <div className="container">
                        <h3 className="academy-subtitle">{t('kycNasilYapilir.subtitle')}</h3>
                        <p className="academy-intro-text">{t('kycNasilYapilir.intro.p1')}</p>
                        <p className="academy-intro-text fw-bold">{t('kycNasilYapilir.intro.p2')}</p>
                        <ul className="academy-list">
                            {t('kycNasilYapilir.intro.items', { returnObjects: true }).map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Bölüm 1: Hazırlık */}
                <div className="academy-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kycNasilYapilir.section1.title')}</h2>
                        <p className="academy-section-text">{t('kycNasilYapilir.section1.intro')}</p>
                        
                        {/* Checklist */}
                        <div className="row g-4">
                            {t('kycNasilYapilir.section1.checklists', { returnObjects: true }).map((checklist, index) => (
                                <div className="col-md-4" key={index}>
                                    <div className="academy-type-card">
                                        <h5>{checklist.title}</h5>
                                        <p className="small">{checklist.subtitle}</p>
                                        <ul className="academy-list-check">
                                            {checklist.items.map((item, iIdx) => (
                                                <li key={iIdx}>{item}</li>
                                            ))}
                                        </ul>
                                        {checklist.note && (
                                            <p className="small mt-3">{checklist.note}</p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Tahmini Süre */}
                        <div className="academy-highlight-box mt-4">
                            <h5>{t('kycNasilYapilir.section1.duration.title')}</h5>
                            <ul>
                                {t('kycNasilYapilir.section1.duration.items', { returnObjects: true }).map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                            <p className="mt-3"><strong>{t('kycNasilYapilir.section1.duration.total')}</strong></p>
                        </div>
                    </div>
                </div>

                {/* Bölüm 2: Gerekli Belgeler */}
                <div className="academy-section ">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kycNasilYapilir.section2.title')}</h2>
                        <p className="academy-section-text">{t('kycNasilYapilir.section2.intro')}</p>
                        
                        {t('kycNasilYapilir.section2.documents', { returnObjects: true }).map((doc, index) => (
                            <div className="academy-type-card mb-4" key={index}>
                                <h4>{doc.title}</h4>
                                <p>{doc.description}</p>
                                
                                {doc.details && doc.details.map((detail, dIdx) => (
                                    <div key={dIdx} className="mt-3">
                                        <h6>{detail.subtitle}</h6>
                                        <ul>
                                            {detail.items.map((item, iIdx) => (
                                                <li key={iIdx}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 3: Sık Karşılaşılan Sorunlar */}
                <div className="academy-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kycNasilYapilir.section3.title')}</h2>
                        <p className="academy-section-text">{t('kycNasilYapilir.section3.intro')}</p>
                        
                        {t('kycNasilYapilir.section3.problems', { returnObjects: true }).map((problem, index) => (
                            <div className="academy-highlight-box mb-4" key={index}>
                                <h5 className="text-danger">{problem.problem}</h5>
                                <strong className="text-success">{t('kycNasilYapilir.section3.solutionsLabel')}</strong>
                                <ol className="mt-2">
                                    {problem.solutions.map((solution, sIdx) => (
                                        <li key={sIdx}>{solution}</li>
                                    ))}
                                </ol>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 4: Pro İpuçları */}
                <div className="academy-section ">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kycNasilYapilir.section4.title')}</h2>
                        <p className="academy-section-text">{t('kycNasilYapilir.section4.intro')}</p>
                        
                        <div className="row g-4">
                            {t('kycNasilYapilir.section4.tips', { returnObjects: true }).map((tip, index) => (
                                <div className="col-md-6" key={index}>
                                    <div className="academy-advantage-card">
                                        <h5>{tip.title}</h5>
                                        <p>{tip.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Özet */}
                <div className="academy-summary-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kycNasilYapilir.summary.title')}</h2>
                        
                        <div className="academy-highlight-box">
                            <ol className="mb-0">
                                {t('kycNasilYapilir.summary.steps', { returnObjects: true }).map((step, index) => (
                                    <li key={index}>{step}</li>
                                ))}
                            </ol>
                        </div>

                        <p className="academy-section-text mt-4">{t('kycNasilYapilir.summary.duration')}</p>
                        <p className="academy-section-text">{t('kycNasilYapilir.summary.approval')}</p>

                        <div className="academy-highlight-box mt-4">
                            <h5>{t('kycNasilYapilir.summary.importantTitle')}</h5>
                            <ul>
                                {t('kycNasilYapilir.summary.importantPoints', { returnObjects: true }).map((point, index) => (
                                    <li key={index}>{point}</li>
                                ))}
                            </ul>
                        </div>

                        {/* İletişim */}
                        <div className="academy-type-card mt-4">
                            <h5>{t('kycNasilYapilir.summary.help.title')}</h5>
                            <ul className="mb-0">
                                {t('kycNasilYapilir.summary.help.contacts', { returnObjects: true }).map((contact, index) => (
                                    <li key={index}>{contact}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <Cta1 
                title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}
            />
        </div>
    );
};

export default KYCNasilYapilir;
